var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 9.91794C12.8328 11.5926 11.656 12.9923 10.0843 13.3359L9.71212 12.2194C10.4144 12.1048 11.0114 11.6766 11.3546 11.0833H9.91675C9.2724 11.0833 8.75008 10.561 8.75008 9.91666V7.58332C8.75008 6.93897 9.2724 6.41666 9.91675 6.41666H11.6306C11.3436 4.11464 9.37985 2.33332 7.00008 2.33332C4.6203 2.33332 2.65658 4.11464 2.36952 6.41666H4.08342C4.72775 6.41666 5.25008 6.93897 5.25008 7.58332V9.91666C5.25008 10.561 4.72775 11.0833 4.08342 11.0833H2.33341C1.68908 11.0833 1.16675 10.561 1.16675 9.91666V6.99999C1.16675 3.77833 3.77842 1.16666 7.00008 1.16666C10.2217 1.16666 12.8334 3.77833 12.8334 6.99999V7.58257V7.58332V9.91666V9.91794ZM11.6667 9.91666V7.58332H9.91675V9.91666H11.6667ZM2.33341 7.58332V9.91666H4.08342V7.58332H2.33341Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/cs.9dcb73118ccd8a23f7d20cbeabd8f581.svg";
export { ForwardRef as ReactComponent };